const STEPS = [
  {
    n: '01',
    title: 'Connect your assistant',
    body: 'Add Zafron as an MCP server in Claude or another client. It takes a minute.',
  },
  {
    n: '02',
    title: 'Ask in plain words',
    body: 'Name the devices and readings you care about. Your assistant picks the charts.',
  },
  {
    n: '03',
    title: 'It updates itself',
    // Not "with every uplink": a dashboard refreshes on its manifest's own
    // cadence (useZafronBridge), which may be off.
    body: 'Saved dashboards live here and refresh on their own schedule. Ask again to change one.',
  },
];

export function HowItWorks() {
  return (
    <ol className="grid divide-y divide-gray-200 overflow-hidden rounded-2xl border border-gray-200 bg-white sm:grid-cols-3 sm:divide-x sm:divide-y-0 dark:divide-gray-800 dark:border-gray-800 dark:bg-gray-900">
      {STEPS.map((s) => (
        <li key={s.n} className="p-6">
          <p className="font-mono text-sm text-blue-700 dark:text-blue-400" aria-hidden="true">{s.n}</p>
          <h3 className="mt-2 font-semibold text-gray-900 dark:text-gray-50">{s.title}</h3>
          <p className="mt-2 text-gray-500 dark:text-gray-400">{s.body}</p>
        </li>
      ))}
    </ol>
  );
}
